import React, {FC, PropsWithChildren} from 'react';

import {InteractionTrackingContext} from '../../../../libs/shared/ui/src/interactionTracking/interactionTrackingContext';
import {
  trackComponentInteraction,
  trackContextInteraction,
  trackInteraction,
} from '../../../services/interactionTracking';

const trackers = {
  trackInteraction,
  trackComponentInteraction,
  trackContextInteraction,
};

// Used to provide a concrete tracking implementation that can be used by shared components in libs.
export const InteractionTrackingProvider: FC<PropsWithChildren<unknown>> = ({children}) => (
  <InteractionTrackingContext.Provider value={trackers}>{children}</InteractionTrackingContext.Provider>
);
